<template>
  <v-container>
    <v-alert
      v-model="isError"
      dismissible
      type="error"
      transition="fade-transition"
    >
      {{ errMessage }}
    </v-alert>
    <h1>Users</h1>
    <v-data-table
      :headers="headers"
      :items="users"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.firstName }} {{ props.item.lastName }}</td>
        <td>{{ props.item.roles }}</td>
        <td>{{ props.item.bannedAt }}</td>
        <td>{{ props.item.local.email }}</td>
        <td>{{ props.item.google.email }}</td>
        <td>{{ props.item.facebook.email }}</td>
        <td>
          <v-icon small @click="editUser(props.item)">edit</v-icon>
          <v-icon small @click="banUser(props.item)">gavel</v-icon>
        </td>
      </template>
    </v-data-table>
    <v-btn to="/admin/users/new">Add</v-btn>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    isError: false,
    errMessage: null,
    users: [],
    headers: [
      { text: 'Name', value: 'firstName' },
      { text: 'Role', value: 'roles' },
      { text: 'Banned Since', value: 'bannedAt' },
      { text: 'Email', value: 'local.email' },
      { text: 'Google', value: 'google.email' },
      { text: 'Facebook', value: 'facebook.email' },
      { text: 'Actions', value: 'firstName' } // no actual value
    ]
  }),
  mounted: function () {
    var _this = this
    this.axios.get('/auth/users')
      .then(function (res) {
        _this.users = res.data
      })
      .catch(this.$root.apiErrorHandler())
  },
  methods: {
    editUser: function (u) {
      this.$router.push('/admin/users/' + u.id)
    },
    banUser: function (u) {
      // Make sure we didn't select ourselves
      if (u.id === this.$auth.user().id) {
        this.errMessage = 'You cannot ban yourself.'
        this.isError = true
        return
      }

      // Set up the right message and action based on whether or not the selected
      // user is currently banned
      var msg = 'Do you want to ban this user?'
      var method = 'POST'
      if (u.bannedAt !== null) {
        msg = 'Do you want to unban this user?'
        method = 'DELETE'
      }

      // Confirm with the user that they want to perform the requested action
      // before actually making the request
      var _this = this
      confirm(msg) &&
      this.axios.request({
        method,
        url: '/auth/users/' + u.id + '/ban'
      })
        .then(function (res) {
          // Update the ban value in our data
          if (method === 'POST') {
            u.bannedAt = res.data.bannedAt
          } else {
            u.bannedAt = null
          }
        })
        .catch(this.$root.apiErrorHandler(function (msg) {
          _this.errMessage = msg
          _this.isError = true
        }))
    }
  }
}
</script>
